import request from './request'
import VueCookies from 'vue-cookies'
import store from '@/store'
import ElementUI, {Drawer} from 'element-ui'

export default {
  replaceHtml (str) {
    console.log(str)
    return str.replace(/<[^>]+>/g, '')
  },
  isHaveAuthor (parCode, code) {
    let isHave = false
    const allRights = store.state.permissions.allRights
    let arr = allRights.map(item => {
      return item[parCode]
    })
    if (arr && arr.length > 0) {
      let newArr = []
      arr.map(item => {
        newArr = newArr.concat(item)
      })
      newArr = [...new Set(newArr)]
      if (newArr.indexOf(code) != -1) {
        isHave = true
      }
    }
    return isHave
  },
  getQueryObj () {
    let obj = {}
    let query = window.location.search.substring(1)
    let vars = query.split('&')
    vars.map(val => {
      let newVal = val.split('=')
      obj[newVal[0]] = newVal[1]
    })
    return obj
  },
  getQueryString (name) {
    let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
    let r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  },
  copy (data) {
    let url = data
    let oInput = document.createElement('input')
    oInput.value = url
    document.body.appendChild(oInput)
    oInput.select()
    document.execCommand('Copy') // 执行浏览器复制命令
    ElementUI.Message['success']('复制成功！')
    oInput.remove()
  },
  downloadFile (res) {
    let headers = res.config.headers
    const showname = JSON.parse(res.config.data).showname
    const content = res.data
    const blob = new Blob([content], {type: headers['Content-Type']}) // 构造一个blob对象来处理数据
    if ('download' in document.createElement('a')) {
      // 支持a标签download的浏览器
      const link = document.createElement('a') // 创建a标签
      link.download = showname // a标签添加属性
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      document.body.appendChild(link)
      link.click() // 执行下载
      URL.revokeObjectURL(link.href) // 释放url
      document.body.removeChild(link) // 释放标签
    } else {
      // 其他浏览器
      navigator.msSaveBlob(blob, showname)
    }
  },
  curMonthDays (year, month) {
    return new Date(year, month, 0).getDate()
  },
  inRecentMonths (n, m) {
    // 返回最近{n} 个月 m 是 你要选择的第几天
    const curDate = new Date()
    let year = curDate.getFullYear()
    let month = curDate.getMonth() + 1
    let day = curDate.getDate()

    if (day < 10) {
      day = `0${day}`
    }
    if (month - n <= 0) {
      month = 12 + month - n
      year -= 1
    } else {
      month = month - n
    }

    if (month < 10) {
      month = `0${month}`
    }

    if (m) {
      let ntime = `${year}-${month}-${day}`
      ntime = ntime.split('-')
      ntime.splice(2, 1)
      ntime.push(m)
      ntime = ntime.join('-')
      return ntime
    } else {
      return `${year}-${month}-${day}`
    }
  },

  // fmt表格日期格式，data日期时间
  formatDate (fmt, date) {
    let ret
    if (date) {
      date = new Date(date)
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        // console.log("(" + k + ")");
        // console.log(new RegExp("(" + k + ")").exec(fmt));
        ret = new RegExp(`(${k})`).exec(fmt)
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
          )
        }
      }
    } else {
      fmt = ''
    }
    return fmt
  },
  formatByte (byteSize) {
    let sizeStr = `${byteSize}B`
    let num = byteSize / 1024
    if (byteSize > 1024) {
      if (num < 1024) {
        sizeStr = `${num.toFixed(2)}KB`
      } else {
        num = byteSize / 1024 / 1024
        sizeStr = `${num.toFixed(2)}MB`
        if (num > 1024) {
          num = byteSize / 1024 / 1024 / 1024
          sizeStr = `${num.toFixed(2)}GB`
          if (num > 1024) {
            num = byteSize / 1024 / 1024 / 1024 / 1024
            sizeStr = `${num.toFixed(2)}TB`
          }
        }
      }
    }
    return sizeStr
  },

  // 路由守卫跳转之前拦截处理

  formatLoginUrl (to) {
    const curUrlObj = window.location
    const originUrl = `${curUrlObj.origin}/`
    // let url = `https://testbgi-iam.genomics.cn/esc-sso/login?service=${originUrl}`
    let url = `https://bgi-iam.genomics.cn/esc-sso/login?service=${originUrl}`
    // let url = `https://logintest.genomics.cn/cas/login?service=${originUrl}`

    // 存在一个bug当用户未登录界面是会跳转到首页，而不是指定页面，如果要修复，还需添加一个404界面
    // let url = `https://bgi-iam.genomics.cn/esc-sso/login?service=${curUrlObj.href}`;
    const query = to.query
    const objKeys = Object.keys(to.query).filter(val => val != '')
    if (objKeys.length > 0) {
      if (objKeys.indexOf('ticket') != -1) {
        let fronturl = curUrlObj.href
          .replace(/\&ticket=|\?ticket=/g, '')
          .replace(query.ticket, '')
        store
          .dispatch('user/login', {
            ticket: to.query.ticket,
            fronturl: encodeURIComponent(fronturl)
          })
          .then(res => {
            const data = res.data
            if (data.code == 0) {
              VueCookies.set('token', data.token)
              localStorage.setItem('userPhoto', data.UserInfo.photo)
              delete data.UserInfo.photo
              VueCookies.set('userInfo', data.UserInfo)
              store.commit('user/updateUserInfo', data.UserInfo)

              window.location.href = fronturl
            } else {
              store.dispatch('user/userLoginOut', {})
            }
          })
      } else {
        // let curUrl = curUrlObj.href.replace(/\&/g, "?");
        window.location.href = `https://bgi-iam.genomics.cn/esc-sso/login?service=${encodeURIComponent(
        // window.location.href = `https://testbgi-iam.genomics.cn/esc-sso/login?service=${encodeURIComponent(
          curUrlObj.href
        )}`
        // window.location.href = `https://logintest.genomics.cn/cas/login?service=${encodeURIComponent(
        //   curUrlObj.href
        // )}`
      }
    } else {
      window.location.href = url
    }
  },
  returnAdminStr (field, arr) {
    let str = ''
    if (arr && arr.length > 0) {
      let newArr = []
      arr.map(item => {
        newArr.push(item[field])
      })
      str = newArr.toString()
    }
    return str
  },
  clearObj (obj) {
    for (let key in obj) {
      if (Array.isArray(obj[key])) {
        obj[key] = []
      } else {
        switch (typeof obj[key]) {
          case 'string':
            obj[key] = ''
            break
          case 'number':
            obj[key] = null
            break
          case 'boolean':
            obj[key] = false
            break
          case 'object':
            obj[key] = null
            break
        }
      }
    }
    return obj
  },
  formatLogStr (obj, tempalte = {
    '100': '%s 启动了云服务器实例(IP地址：%s)',
    '101': '%s 关闭了云服务器实例(IP地址：%s)',
    '102': '%s 强制关闭云服务器实例(IP地址：%s)',
    '103': '%s 重启了云服务器实例(IP地址：%s)',
    '104': '%s 强制重启了云服务器实例(IP地址：%s)',
    '105': '%s 重置了云服务器密码(IP地址：%s)',
    '106': '%s 将 %s 实例(%s) 管理员设置为 %s',
    '107': '%s 将 %s 实例(%s) 归属人由 %s 更改为 %s,理由:%s',
    '108': '%s 创建了一台云服务器%s,资源池%s,IP地址：%s',
    '109': '实例(%s)被释放',
    '110': '%s %s 配置 %s 由 %s 变更为 %s',
    '111': '%s 将%s 设置为%s',
    '112': '%s 将%s 从%s用户列表中删除',
    '113': '%s 修改了计费规则,具体修改内容为:%s',
    '114': '系统向%s发送离职用户提醒',
    '115': '%s 调整了%s月账单明细,具体修改内容为:%s',
    '150': '%s 将%s 名称修改为:%s',
    '151': '%s 将物理机 (%s) 计费配置由 %s 变更为 %s',
    '152': '%s 将服务器 (%s) HIDS状态标记为:%s,原因:%s',
    '153': '%s 将 %s 备注修改为:%s',
    '154': '%s 将 云服务器%s 自定义字段%s 由 %s 修改为: %s',
    '200': '%s 将%s 账单挂账人修改为%s'
  }, times = false) {
    // console.log(obj);
    // let templateObj = {
    //     "100": "%s 启动了云服务器实例(IP地址：%s)",
    //     "101": "%s 关闭了云服务器实例(IP地址：%s)",
    //     "102": "%s 强制关闭云服务器实例(IP地址：%s)",
    //     "103": "%s 重启了云服务器实例(IP地址：%s)",
    //     "104": "%s 强制重启了云服务器实例(IP地址：%s)",
    //     "105": "%s 重置了云服务器密码(IP地址：%s)",
    //     "106": "%s 将 %s 实例(%s) 管理员设置为 %s",
    //     "107": "%s 将 %s 实例(%s) 归属人由 %s 更改为 %s,理由:%s",
    //     "108": "%s 创建了一台云服务器%s,资源池%s,IP地址：%s",
    //     "109": "实例(%s)被释放",
    //     "110": "%s %s 配置 %s 由 %s 变更为 %s",
    //     "111": "%s 将%s 设置为%s",
    //     "112": "%s 将%s 从%s用户列表中删除",
    //     "113": "%s 修改了计费规则,具体修改内容为:%s",
    //     "114": "系统向%s发送离职用户提醒",
    //     "115": "%s 调整了%s月账单明细,具体修改内容为:%s",
    //     "150": "%s 将%s 名称修改为:%s",
    //     "151": "%s 将物理机 (%s) 计费配置由 %s 变更为 %s",
    //     "152": "%s 将服务器 (%s) HIDS状态标记为:%s,原因:%s",
    //     "153": "%s 将 %s 备注修改为:%s",
    //     "154": "%s 将 云服务器%s 自定义字段%s 由 %s 修改为: %s",
    //     "200": "%s 将%s 账单挂账人修改为%s"
    // };
    // console.log(obj);
    // console.log(tempalte);
    let templateObj = tempalte
    let templateStr = templateObj[obj.eventkey]
    // console.log(templateStr);
    for (let i = 0; i < obj.data.length; i++) {
      templateStr = templateStr.replace(
        '%s',
        `<strong>${obj.data[i]}</strong>`
      )
    }
    if (times) {
      templateStr += `&nbsp;&nbsp;&nbsp;&nbsp; 操作时间： <strong>${obj.timestring}</strong>`
    }
    // console.log(templateStr)
    return templateStr
  },
  manageback (val) {
    // let a = 1;
    if (
      (typeof val === 'string' && val.length === 0) || !val
      //     val === null ||
      //     (typeof val === "string" && val.length === 0) //||val
      //    || val === undefined
    ) {
      return '---'
    } else {
      return val
    }
  },
  analysisPsd (type, val) {
    if (type === 'category') {
      switch (val) {
        case 0:
          return 'SQL注入'
        case 1:
          return '未授权访问'
        case 2:
          return '敏感信息泄露'
        case 3:
          return 'XML外部实体注入'
        case 4:
          return '跨站脚本攻击'
        case 5:
          return '不安全的反序列'
        case 6:
          return '客户端请求伪造'
        case 7:
          return '服务端请求伪造'
        case 8:
          return '命令执行,'
        case 9:
          return '代码执行'
        case 10:
          return '任意文件上传'
        case 11:
          return '任意文件读取'
        case 12:
          return '拒绝服务攻击'
        case 13:
          return '目录遍历'
        case 14:
          return '恶意后门'
        case 15:
          return '本地提权'
        case 16:
          return '注入漏洞'
      }
    } else if (type === 'executeType') {
      switch (val) {
        case 1:
          return '版本比对'
        case 1:
          return 'POC检测'
      }
    } else if (type === 'severity') {
      switch (val) {
        case 0:
          return '信息'
        case 1:
          return '低危'
        case 2:
          return '中危'
        case 3:
          return '高危'
        case 4:
          return '危急'
      }
    } else if (type === 'restartOpts') {
      switch (val) {
        case 0:
          return '未知'
        case 1:
          return '无需重启'
        case 2:
          return '服务重启'
        case 3:
          return '系统重启(仅linux)'
      }
    } else if (type === 'impacts') {
      switch (val) {
        case 1:
          return '纵深防御'
        case 2:
          return '拒绝服务'
        case 3:
          return '权限提升'
        case 4:
          return '信息泄露'
        case 5:
          return '远程代码执行'
        case 6:
          return '安全特征绕过'
        case 7:
          return '电子欺骗'
        case 8:
          return '数据篡改'
      }
    } else if (type === 'weakType') {
      switch (val) {
        case 1:
          return '空密码'
        case 2:
          return '默认弱密码'
        case 3:
          return '跟用户名相同'
        case 4:
          return '常见弱密码'
      }
    } else if (type === 'accountStatus') {
      // accountStatus 账号状态：对于windows：0-正常；1-锁定；2-禁用；对于linux主机：0-禁用；1-正常）
    }
  },
  verifyArray (oldData, newData) {
    function isObject (obj) {
      return Object.prototype.toString.call(obj) === '[object Object]'
    }

    /**
     * 判断此类型是否是Array类型
     * @param {Array} arr
     */
    function isArray (arr) {
      return Object.prototype.toString.call(arr) === '[object Array]'
    }

    /**
     *  深度比较两个对象是否相同
     * @param {Object} oldData
     * @param {Object} newData
     */
    function equalsObj (oldData, newData) {
      // 类型为基本类型时,如果相同,则返回true
      if (oldData === newData) return true
      if (
        isObject(oldData) &&
        isObject(newData) &&
        Object.keys(oldData).length === Object.keys(newData).length
      ) {
        // 类型为对象并且元素个数相同

        // 遍历所有对象中所有属性,判断元素是否相同
        for (const key in oldData) {
          if (oldData.hasOwnProperty(key)) {
            if (!equalsObj(oldData[key], newData[key])) { // 对象中具有不相同属性 返回false
              return false
            }
          }
        }
      } else if (
        isArray(oldData) &&
        isArray(oldData) &&
        oldData.length === newData.length
      ) {
        // 类型为数组并且数组长度相同

        for (let i = 0, length = oldData.length; i < length; i++) {
          if (!equalsObj(oldData[i], newData[i])) { // 如果数组元素中具有不相同元素,返回false
            return false
          }
        }
      } else {
        // 其它类型,均返回false
        return false
      }
      // 走到这里,说明数组或者对象中所有元素都相同,返回true
      return true
    }

    return equalsObj(oldData, newData)
  }

}



// WEBPACK FOOTER //
// ./src/assets/utilits/common.js